@if (quicklinks) {
<div class="newsfeed-quicklinks__headline mat-caption" i18n="@@featureNewsfeed-quinklinksHeadline">Top Themen</div>
<div class="newsfeed-quicklinks__wrapper">
  <mat-chip-listbox>
    @for (quicklink of quicklinks; track identifyQuicklink($index, quicklink)) {
    <mat-chip-option selectable="false" class="newsfeed-quicklinks__chip">
      @if (fairId) {
      <a
        [routerLink]="['/fairs', fairId, 'search']"
        [queryParams]="{
          filter: stringifyFilter(quicklink.filter)
        }"
        (click)="onClick($event)">
        {{ quicklink.name }}
      </a>
      } @else {
      {{ quicklink.name }}
      }
    </mat-chip-option>
    }
  </mat-chip-listbox>
</div>
}
